{
  "title": "收件箱",
  "totalBadge": "{{count}} 項",
  "viewAll": "查看全部",
  "loading": "載入中…",
  "emptySection": "全部已處理",
  "loadError": "無法載入此部分"
}
